import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { GoogleTagManager } from './components/GoogleTagManager';
import { MicrosoftClarity } from './components/MicrosoftClarity';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-bg text-ink font-sans selection:bg-rose/20 selection:text-rose-deep" data-id="element-1">
        <GoogleTagManager data-id="element-2" />
        <MicrosoftClarity data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
          <Route path="/termos" element={<TermsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/privacidade" element={<PrivacyPage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </div>
    </BrowserRouter>;
}